import Link from "next/link";
import useAuthContext from "../../context/AuthContext";

const InitialSettingNavi = (props) => {

  // subdomainと署名
  const {currentShop, currentAuthority} = useAuthContext();
  const subdomain = currentShop?.subdomain;

  // 転送設定
  const forwardings = currentShop?.forwardings || [];
  const headerFroms = currentShop?.headerFroms || {};

  // お問い合わせフォーム
  const hash = currentShop?.webToTicketHash;

  return (<div>
    <h2 className="text-3xl font-bold mb-5">初期設定サポート</h2>
    { !subdomain && (<div className="p-5 border mb-5 bg-white">
      <h3 className="text-2xl font-bold mb-5">サブドメインを設定してください</h3>
      <p className="text-xl">
        お客様専用のサブドメインです。配信メールの送信元のサブドメインになります。<br />
      </p>
      <p className="text-2xl my-3">
        ex.) support-address@<span className="text-red-600 font-bold">subdomain</span>.supportdesk.link<br />
      </p>
      <p className="text-2xl my-3">
        詳しくは、<Link target="_blank" className="text-blue-500 text-2xl font-bold" href={`/settings/shop/edit`}>
          設定ページ
        </Link>よりご覧ください。
      </p>
    </div>)}

    { !forwardings?.length && (<div className="p-5 border mb-5 bg-white">
      <h3 className="text-2xl font-bold mb-5">転送先サポートアドレスを設定してください</h3>
      <p className="text-xl">
        転送先サポートアドレスへ、受信メールを転送してください。<br />
        そのメールがお問い合せになります。<br />
        また、本サービスから配信するメールのサブドメインにもなります。
      </p>
      <p className="text-2xl my-3">
        ex.) <span className="text-red-600 font-bold">support-address</span>@subdomain.supportdesk.link<br />
      </p>
      <p className="text-xl">
        詳しくは、<Link target="_blank" className="text-blue-500 text-2xl font-bold" href={`/settings/forwarding`}>
          設定ページ
        </Link>よりご覧ください。
      </p>
    </div>)}

    { !Object.keys(headerFroms).length && (<div className="p-5 border mb-5 bg-white">
      <h3 className="text-2xl font-bold mb-5">差出人アドレスを設定してください</h3>
      <p className="text-xl">
        本サービスから配信するメールの返信先になります。<br />
        複数設定することで、本サービスからの送信時に選択することができます。
      </p>
      <p className="text-xl">
        詳しくは、<Link target="_blank" className="text-blue-500 text-2xl font-bold" href={`/settings/email/froms/edit`}>
          設定ページ
        </Link>よりご覧ください。
      </p>
    </div>)}

    { !hash && (<div className="p-5 border mb-5 bg-white">
      <h3 className="text-2xl font-bold mb-5">お問い合わせフォームを有効化してください</h3>
      <p className="text-xl">
        お問い合わせフォームを有効化すればカスタマーからのお問い合わせがAll In One Support Deskに届きます。<br />
        フォームの内容にはカスタムフィールドなど、独自の内容を追加することができます。
      </p>
      <p className="text-xl">
        詳しくは、<Link target="_blank" className="text-blue-500 text-2xl font-bold" href={`/settings/webToTicket/edit`}>
          設定ページ
        </Link>よりご覧ください。
      </p>
    </div>)}

    { hash && forwardings?.length && subdomain && <p className="text-2xl mb-5">初期設定は完了しています。</p> }

  </div>)

}

export default InitialSettingNavi